module.exports = __webpack_public_path__ + "assets/img/4_908_big.d921b319.jpg";